import { useQuery } from "@apollo/client";
import { GET_PICKUP_POINTS } from "./MapOverviewTrafficLite.queries";

export const usePickupPoints = (clientLoginId) => {
  const { data, loading, error, refetch } = useQuery(GET_PICKUP_POINTS, {
    variables: {
      clientLoginId,
    },
    skip: !clientLoginId,
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-and-network",
  });

  const pickupPoints = data?.getLtmAois || [];
  
  console.log('🔵 usePickupPoints - loading:', loading, 'error:', error, 'points:', pickupPoints?.length);

  return {
    pickupPoints,
    loading,
    error,
    refetch,
  };
};
